import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateIndoorMap, IndoorMapDto, UpdateIndoorMap } from './mappa-indoor-dto';

@Injectable({
  providedIn: 'root'
})
export class MappaIndoorService {

  private url = `${environment.apiUrl}/missions/indoor-maps`;

  constructor(private http: HttpClient) { }

  getAll(missionId?: string | null, clientId?: string | null): Observable<IndoorMapDto[]> {
    let params = new HttpParams();
    if (missionId) params = params.set('missionId', missionId);
    if (clientId) params = params.set('clientId', clientId);

    return this.http.get<IndoorMapDto[]>(this.url, { params });
  }

  read(missionId: string, clientId: string, floor: number): Observable<IndoorMapDto> {
    return this.http.get<IndoorMapDto>(`${this.url}/${missionId}/${clientId}/${floor}`);
  }

  create(data: CreateIndoorMap): Observable<IndoorMapDto> {
    return this.http.post<IndoorMapDto>(this.url, data);
  }

  update(missionId: string, clientId: string, floor: number, data: UpdateIndoorMap): Observable<IndoorMapDto> {
    return this.http.put<IndoorMapDto>(`${this.url}/${missionId}/${clientId}/${floor}`, data);
  }

  delete(missionId: string, clientId: string, floor: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${missionId}/${clientId}/${floor}`);
  }
}
